<template>
  <div>
    <div class="breadcrumb">
      <h1 style="color: #AC8400;">My Activity</h1>
    </div>

    <!-- Breadcrumbs -->
    <div style="padding: 10px; background-color: #F2F2F2">
      <router-link to="/dashboard">
        Dashboard
      </router-link>
      /

      <router-link to="/marketing">
        Marketing
      </router-link>
      / <b>My Activity</b> /
    </div>
    <!-- End of breadcrumbs -->

    <div class="separator-breadcrumb border-top"></div>
    <div class="row mb-4">
      <div class="col-md-12 mb-4">
        <div class="card text-left">
          <div class="card-body">
            <form @submit.prevent="submitForm">
              <!-- Title -->
              <div class="mb-3">
                <label for="title" class="form-label">Title</label>
                <input v-model="data.title" type="text" id="title" class="form-control"
                  placeholder="My Activity Title..." required />
                <div v-if="errors.title">
                  <small class="text-danger">{{ errors.title }}</small>
                </div>
              </div>
              <!-- Subtitle -->
              <div class="mb-3">
                <label for="short_description" class="form-label">Subtitle</label>
                <input type="text" v-model="data.short_description" id="short_description" class="form-control"
                  placeholder="My Activity Title..." required />
                <div v-if="errors.short_description">
                  <small class="text-danger">{{
                    errors.short_description
                  }}</small>
                </div>
              </div>
              <div class="mb-3">
                <label for="reminder" class="form-label">Countdown reminders for RSVP</label>
                <div class="d-flex align-items-center">
                  <input v-model="data.reminder" type="number" id="reminder" class="form-control me-2 text-right"
                    style="width: 60px;" placeholder="" required />

                  <p class="mb-0 ml-2 me-2">Days</p>
                  <button class="btn btn-primary ml-2" @click="addDays">
                    +
                  </button>
                </div>
                <div v-if="errors.reminder">
                  <small class="text-danger">{{ errors.reminder }}</small>
                </div>
                <div class="mt-3">
                  <button type="submit" class="btn btn-primary rounded mb-3">
                    Update
                  </button>
                </div>
              </div>
            </form>

            <router-link to="/marketing/my-activity/new" class="text-white">
              <button type="submit" class="btn btn-primary rounded mb-3">
                New My Activity
              </button>
            </router-link>

            <div>
              <h4 class="card-title mb-3">
                Active
              </h4>
              <p>
                Note: On the specified period and time, the following will be
                automatically sent and displayed to the selected users:
                <span class="text-primary text-decoration-underline ml-3" style="cursor: pointer;"
                  @click="toggleDetails">
                  {{ isVisible ? "" : "Read more" }}
                </span>
              </p>

              <!-- Hidden content by default, revealed on "Read more" click -->
              <div v-if="isVisible" id="extraDetails">
                <ol>
                  <li>
                    A daily push notification, except when the user has RSVP or
                    if the quota is full (for RSVP), or when the user has
                    requested for call (for Request for Call)
                    <ul>
                      <li>
                        No need login for push notification. However, if the
                        user happened to uninstall the app, they may not receive
                        the push notification.
                      </li>
                    </ul>
                  </li>
                  <li>
                    Display a popup at Homepage:
                    <ul>
                      <li>Condition as below:</li>
                      <ul>
                        <li>
                          If already logged in: Popup every time user opens the
                          app except when the user has RSVP, or if the quota is
                          full (for RSVP), or when the user has requested for
                          call (for Request for Call).
                        </li>
                        <li>
                          If not logged in: Popup every time user logs in except
                          when the user has RSVP, or if the quota is full (for
                          RSVP), or when the user has requested for call (for
                          Request for Call).
                        </li>
                      </ul>
                    </ul>
                  </li>
                  <li>
                    An in-app notification and inbox on the first day only.
                    <ul>
                      <li>
                        In-app notification will be displayed for 14 days only.
                      </li>
                      <li>
                        The inbox notification will remain and not disappear.
                        <span @click="toggleDetails" class="text-primary text-decoration-underline"
                          style="cursor: pointer;">
                          Read less
                        </span>
                      </li>
                    </ul>
                  </li>
                </ol>
              </div>
              <hr />
              <div class="table-responsive">
                <table id="my_activity_tbl" class="display table table-striped table-bordered"
                  style="width:100%; text-align: center;">
                  <thead>
                    <tr>
                      <th>No.</th>
                      <th>Title</th>
                      <th>Period</th>
                      <th>Time</th>
                      <th>Type</th>
                      <th>Created By</th>
                      <th>Created At</th>
                      <th>Image</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, index) in activityData">
                      <td>{{ index + 1 }}</td>
                      <td>{{ item.title }}</td>
                      <td>{{ item.period }}</td>
                      <td>{{ item.notification_time }}</td>
                      <td>{{ item.type }}</td>
                      <td>{{ item.created_by }}</td>
                      <td>{{ item.created_at }}</td>
                      <td class="w-20" style="max-height: 100px;">
                        <div class="d-flex align-items-center justify-content-center" style="max-height: 100px;">
                          <img :src="item.image" alt="Image" class="img-fluid"
                            style="max-height: 100px; object-fit: contain;" />
                        </div>
                      </td>

                      <td>
                        <button :disabled="item.cancelled_at !== null" :class="{
                          'btn btn-secondary btn-rounded btn-block':
                            item.cancelled_at !== null,
                          'btn btn-danger btn-rounded btn-block':
                            item.cancelled_at === null &&
                            item.active === 'Active',
                          'btn btn-success btn-rounded btn-block':
                            item.cancelled_at === null &&
                            item.active === 'Inactive'
                        }" @click="handleStatus(item.id, item.active)">
                          {{
                            item.cancelled_at !== null
                              ? "Cancelled"
                              : item.active == "Active"
                                ? "Deactivate"
                                : "Activate"
                          }}
                        </button>

                        <button class="btn btn-success btn-rounded btn-block" @click="handleEdit(item.id)">
                          {{
                            item.cancelled_at !== null
                              ? "View Details"
                              : "Edit Details"
                          }}
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getMyActivity,
  toggleStatus,
  updateMyActivity
} from "../../../services/MyActivityService";

export default {
  name: "my-activity",

  data() {
    return {
      isVisible: false,
      data: {
        id: null,
        type: null,
        title: null,
        short_description: null,
        reminder: null,
        active: 1,
      },
      activityData: [],
      main: [],
      errors: []
    };
  },

  watch: {
    main: {
      handler(newMain) {
        this.data.id = newMain ? newMain.id : "";
        this.data.title = newMain ? newMain.title : "";
        this.data.short_description = newMain ? newMain.short_description : "";
        this.data.reminder = newMain ? newMain.reminder : "";
        this.data.type = newMain ? newMain.type : "";
      },
      deep: true,
      immediate: true
    }
  },

  methods: {
    async fetchData() {
      try {
        const response = await getMyActivity();

        if (response.data.success) {
          this.destroyDatatable();
          this.main = response.data.data.main;
          this.activityData = response.data.data.activities;

          this.$nextTick(() => {
            $("#my_activity_tbl").DataTable({
              pageLength: 5,
              dom: "Bfrtip",
              buttons: ["excel", "pdf"]
            });
          });
        }
      } catch (e) {
        console.error(e);
      }
    },

    destroyDatatable() {
      $("#my_activity_tbl")
        .DataTable()
        .destroy();
    },

    toggleDetails() {
      this.isVisible = !this.isVisible;
    },

    handleEdit(myActivity_id) {
      this.$router
        .push({ name: "activity_detail", params: { id: myActivity_id } })
        .catch(err => {
          if (err.name !== "NavigationDuplicated") {
            console.error(err);
          }
        });
    },

    addDays() {
      this.data.reminder = this.data.reminder + 1;
    },

    async handleStatus(id, active) {
      let status;
      if (active == "Inactive") {
        status = 1;
      } else {
        status = 0;
      }
      try {
        const response = await toggleStatus({ active: status }, id);

        if (response.data.success) {
          swal("Success!", response.data.message);
          this.isModalVisible = false;
          this.fetchData();
        }
      } catch (e) {
        swal("Error!", e);
        1;
        this.isModalVisible = false;
      }
    },

    async submitForm() {
      try {
        const response = await updateMyActivity(this.data, this.data.id);
        if (response.data.success) {
          swal("Success!", response.data.message, "success");
          this.isModalVisible = false;
          this.fetchData();
        }
      } catch (e) {
        swal("Error!", e, "error");
        this.isModalVisible = false;
      }
    }
  },
  mounted() {
    this.fetchData();
  }
};
</script>
